import React from 'react'

import { ModalCenterFont } from './styles'
//import '../../../../node_modules/@govbr/dsgov/dist/dsgov.min.css';;

function ModalMessage({ appear, text, title }) {
  return (
    <ModalCenterFont appear={appear}>
      <div className='br-modal is-medium' id='modal'>
        <div className='br-card'>
          <div className='container-fluid p-4'>
            {
              title && <div className="br-modal-header">
                          <div className="br-modal-title">
                              <strong>{title}</strong>
                          </div>
                      </div>
            }
            {/* <div className='br-modal-body' >{text}</div> */}
            <div dangerouslySetInnerHTML={{ __html: text }} />
            <div className='br-modal-footer justify-content-center'>
            </div>
          </div>
        </div>
      </div>
    </ModalCenterFont>
  )
}

export default ModalMessage
